(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const toggle = document.getElementById('mobileMenuToggle');
  const drawer = document.getElementById('mobileDrawer');
  const closeBtn = document.getElementById('drawerClose');
  const overlay = document.getElementById('mobileDrawerOverlay');

  // --- Drawer open/close ---
  toggle.addEventListener('click', () => {
    drawer.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent body scroll when menu is open
  });
  
  function closeDrawer() {
    drawer.classList.remove('open');
    overlay.classList.remove('active');
    document.body.style.overflow = ''; // Restore body scroll
  }
  
  closeBtn.addEventListener('click', closeDrawer);
  
  // Close drawer when clicking overlay
  overlay.addEventListener('click', closeDrawer);

  // Close drawer when clicking on any link
  const navLinks = drawer.querySelectorAll('a');
  navLinks.forEach(link => {
    link.addEventListener('click', closeDrawer);
  });

  // --- Submenu toggles ---
  const submenuToggles = drawer.querySelectorAll('.submenu-toggle');
  submenuToggles.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const parentWrapper = this.closest('.mobile-nav__item-wrapper, .mobile-submenu__item-wrapper');
      const nextSubmenu = parentWrapper.querySelector(':scope > .mobile-submenu, :scope > .mobile-submenu--level-2');

      // Close any open sibling submenus at same level
      const siblingToggles = parentWrapper.parentElement.querySelectorAll(':scope > .mobile-nav__item-wrapper > .mobile-submenu.open, :scope > .mobile-submenu__item-wrapper > .mobile-submenu.open');
      siblingToggles.forEach(sub => {
        if (sub !== nextSubmenu) sub.classList.remove('open');
      });

      // Toggle this submenu
      if (nextSubmenu) {
        nextSubmenu.classList.toggle('open');
        this.classList.toggle('active');
        this.textContent = nextSubmenu.classList.contains('open') ? '−' : '+';
      }
    });
  });
});

// Predictive search functionality
(function(){
  function initPredictiveSearch(inputSelector, resultsSelector) {
    const input = document.querySelector(inputSelector);
    const resultsEl = document.querySelector(resultsSelector);
    if (!input || !resultsEl) return;

    let activeIndex = -1;
    let currentItems = [];
    let debounceTimer;

    function formatPrice(p) {
      try {
        if (!p) return '';
        return Shopify.formatMoney ? Shopify.formatMoney(p, window.Shopify && window.Shopify.money_format) : p;
      } catch (e) { return p; }
    }

    function buildItemHTML(product) {
      const img = product.image || '//cdn.shopify.com/s/files/1/0000/0001/files/no-image.png';
      const title = product.title || '';
      const price = (product.price && product.price) ? formatPrice(product.price) : '';
      return `
        <a class="predictive-item" href="${product.url}">
          <img class="predictive-item__img" src="${img}" alt="${title}">
          <div class="predictive-item__meta">
            <div class="predictive-item__title">${title}</div>
            <div class="predictive-item__price">${price}</div>
          </div>
        </a>
      `;
    }

    function renderResults(products, query) {
      currentItems = products;
      activeIndex = -1;

      if (!products.length) {
        resultsEl.innerHTML = `<div class="predictive-item" style="pointer-events:none">No results for "${escapeHtml(query)}"</div>`;
        resultsEl.classList.add('visible');
        return;
      }

      let html = products.map(p => buildItemHTML(p)).join('');
      html += `<a class="predictive-view-all" href="/search?q=${encodeURIComponent(query)}">View all results for "${escapeHtml(query)}"</a>`;
      resultsEl.innerHTML = html;
      resultsEl.classList.add('visible');

      const anchors = resultsEl.querySelectorAll('.predictive-item');
      anchors.forEach((a, idx) => {
        a.addEventListener('mouseenter', () => setActive(idx));
        a.addEventListener('mouseleave', () => setActive(-1));
      });
    }

    function setActive(index) {
      const anchors = resultsEl.querySelectorAll('.predictive-item');
      anchors.forEach((a, i) => a.classList.toggle('highlight', i === index));
      activeIndex = index;
    }

    function escapeHtml(text) {
      return text.replace(/[&<>"']/g, function(m) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]; });
    }

    input.addEventListener('keydown', function(e) {
      const visible = resultsEl.classList.contains('visible');
      if (!visible) return;

      const anchors = resultsEl.querySelectorAll('.predictive-item');
      if (!anchors.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        const next = (activeIndex + 1) % anchors.length;
        setActive(next);
        anchors[next].focus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        const prev = (activeIndex - 1 + anchors.length) % anchors.length;
        setActive(prev);
        anchors[prev].focus();
      } else if (e.key === 'Enter') {
        if (activeIndex >= 0 && anchors[activeIndex]) {
          anchors[activeIndex].click();
          e.preventDefault();
        }
      } else if (e.key === 'Escape') {
        resultsEl.classList.remove('visible');
      }
    });

    input.addEventListener('input', function(e) {
      const query = this.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        resultsEl.classList.remove('visible');
        resultsEl.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(() => {
        fetchSuggestions(query);
      }, 220);
    });

    function fetchSuggestions(query) {
      const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6`;
      fetch(url)
        .then(r => r.json())
        .then(data => {
          const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          const mapped = products.map(p => ({
            title: p.title,
            url: p.url,
            image: (p.image && p.image.src) ? p.image.src : (p.image || ''),
            price: (p.price && p.price.amount) ? p.price.amount : (p.price || '')
          }));
          renderResults(mapped, query);
        })
        .catch(() => {
          resultsEl.classList.remove('visible');
          resultsEl.innerHTML = '';
        });
    }

    document.addEventListener('click', function(e) {
      if (!resultsEl.contains(e.target) && e.target !== input) {
        resultsEl.classList.remove('visible');
      }
    });
  }

  // Initialize for both desktop and mobile search
  initPredictiveSearch('.search__input', '#predictive-search');
  initPredictiveSearch('#SearchMobile', '#predictive-search-mobile');
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
